import { createContext, useContext } from 'react';
import { type AuthSession } from '../domain/session';
import { type AuthRepository } from './auth.repository';

export type AuthState =
  | { status: 'loading'; session: null }
  | { status: 'unauthenticated'; session: null }
  | { status: 'authenticated'; session: AuthSession };

export const AuthContext = createContext<AuthState | null>(null);
export const AuthRepositoryContext = createContext<AuthRepository | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}

export function useAuthRepository(): AuthRepository {
  const ctx = useContext(AuthRepositoryContext);
  if (!ctx) throw new Error('useAuthRepository must be used inside <AuthProvider>');
  return ctx;
}
